/* eslint-disable semi */
import { env } from '../../../env';
/* -------------------------------------------------------------------------- */
/*                                 APIBASEURL                                 */
/* -------------------------------------------------------------------------- */
const API_BASE_URL = env.VITE_API_BASE_URL;
export default API_BASE_URL;
